import { render, staticRenderFns } from "./FormItemSR.vue?vue&type=template&id=3ffb7fec"
import script from "./FormItemSR.vue?vue&type=script&lang=js"
export * from "./FormItemSR.vue?vue&type=script&lang=js"
import style0 from "./FormItemSR.vue?vue&type=style&index=0&id=3ffb7fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports